import Entity from "./Entity";
import IMei from "./IMei";

export default interface IDasn extends Entity {
	year?: number;
	status?: DasnStatus;
	serviceValue?: number;
	productValue?: number;
	receipt?: string;
	mei?: string | IMei;
}

export enum DasnStatus {
	pending = 0,
	delivered = 1,
	due = 3
}
